<template>
  <LibraryListItem>
    <ReqTitleCell :title="title" :on-hold="onHold" />
    <ReqIdCell :ats-req-id="atsReqId" />
    <RequisitionListCount
      :total="totalJobPosts"
      :tooltip-values="{
        Draft: draftJobPosts,
        Published: publishedJobPosts,
        Unpublished: unpublishedJobPosts,
      }"
    />
    <RequisitionListCount
      class="applicants"
      :total="totalApplicants"
    />
    <div class="closed-at">
      <p>
        {{ formatClosedAtDate(closedAt) }}
      </p>
    </div>
    <ReqDepartmentCell :department-name="departmentName" />
    <ReqHiringManagerCell :hiring-managers="hiringManagers" />
  </LibraryListItem>
</template>

<script setup>
import LibraryListItem from '@/components/shared/LibraryListItem.vue';
import RequisitionListCount from '@/components/requisitions/RequisitionListCount.vue';
import ReqTitleCell from '@/components/requisitions/listItemCells/ReqTitleCell.vue';
import ReqIdCell from '@/components/requisitions/listItemCells/ReqIdCell.vue';
import ReqDepartmentCell from '@/components/requisitions/listItemCells/ReqDepartmentCell.vue';
import ReqHiringManagerCell from '@/components/requisitions/listItemCells/ReqHiringManagerCell.vue';
import { formatDate } from '@/helpers/date';

defineProps({
  title: {
    type: String,
    default: '',
  },
  onHold: {
    type: Boolean,
    default: false,
  },
  atsReqId: {
    type: String,
    default: '',
  },
  draftJobPosts: {
    type: Number,
    default: 0,
  },
  publishedJobPosts: {
    type: Number,
    default: 0,
  },
  unpublishedJobPosts: {
    type: Number,
    default: 0,
  },
  totalJobPosts: {
    type: Number,
    default: 0,
  },
  closedAt: {
    type: String,
    default: '',
  },
  totalApplicants: {
    type: Number,
    default: 0,
  },
  departmentName: {
    type: String,
    default: '',
  },
  hiringManagers: {
    type: Array,
    default: () => [],
  },
});

const formatClosedAtDate = (date) => {
  if (!date) return '';

  return formatDate(date, 'MM/dd/yyyy');
};
</script>

<style lang="less" scoped>
.closed-at p {
  font-size: 13px;
  font-weight: 500;
}
</style>
